import { Leaf } from "lucide-react";
import { Reveal, Chapter } from "./Reveal";
import { scrollToId } from "@/lib/scroll";

const CAKE_FLAVORS = [
  "Chocolate", "Vanilla", "Strawberry", "Ube", "Mocha / Espresso",
  "Lemon", "Red Velvet", "Confetti", "Pistachio", "Matcha",
];

const BUTTERCREAM = ["Vanilla", "Chocolate", "Strawberry", "Lemon", "Mocha", "Matcha", "Cream Cheese"];

const SEASONAL = [
  { name: "Pumpkin Spice", pairing: "with white chocolate pumpkin spice buttercream" },
  { name: "Caramel Apple", pairing: "with white chocolate cinnamon buttercream" },
  { name: "Pistachio Raspberry", pairing: "with white chocolate pistachio buttercream" },
];

const FlavorList = ({ title, items, testid }) => (
  <div data-testid={testid}>
    <h3 className="font-accent text-[11px] font-bold uppercase tracking-[0.28em] text-[#C48B71]">{title}</h3>
    <ul className="mt-6">
      {items.map((f, i) => (
        <Reveal key={f} delay={i * 0.04}>
          <li className="flex items-center justify-between border-b border-[#E8D8D3]/80 py-3.5">
            <span className="font-display text-xl font-light text-[#2D2422] sm:text-2xl">{f}</span>
            <span className="font-display text-sm italic text-[#C48B71]/70">{String(i + 1).padStart(2, "0")}</span>
          </li>
        </Reveal>
      ))}
    </ul>
  </div>
);

const Flavors = () => (
  <section id="flavors" className="scroll-mt-24 bg-[#F4EFEB] py-24 sm:py-32" data-testid="flavors-section">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <Reveal>
        <Chapter num="04" label="Flavors" />
      </Reveal>
      <Reveal delay={0.1}>
        <h2 className="mt-6 max-w-xl font-display text-4xl font-light leading-tight tracking-tight text-[#2D2422] sm:text-5xl">
          Pick Your Flavor
        </h2>
      </Reveal>

      <div className="mt-14 grid grid-cols-1 gap-16 lg:grid-cols-2">
        <Reveal delay={0.15}>
          <FlavorList title="Cake Flavors" items={CAKE_FLAVORS} testid="cake-flavors-list" />
        </Reveal>
        <Reveal delay={0.25}>
          <FlavorList title="Buttercream Flavors" items={BUTTERCREAM} testid="buttercream-flavors-list" />
        </Reveal>
      </div>

      <Reveal delay={0.2} className="mt-16">
        <div
          className="rounded-3xl border border-[#E8D8D3] bg-[#FDFBF7] p-8 sm:p-12"
          data-testid="seasonal-flavors"
        >
          <div className="flex items-center gap-3">
            <span className="flex h-10 w-10 items-center justify-center rounded-full bg-[#C48B71]/10 text-[#C48B71]">
              <Leaf size={18} strokeWidth={1.5} />
            </span>
            <h3 className="font-display text-3xl font-light text-[#2D2422]">Seasonal Flavors</h3>
          </div>
          <div className="mt-8 grid grid-cols-1 gap-x-12 md:grid-cols-3">
            {SEASONAL.map((s, i) => (
              <Reveal key={s.name} delay={i * 0.1}>
                <div
                  className="border-b border-[#E8D8D3]/80 py-5 md:border-b-0 md:py-0"
                  data-testid={`seasonal-flavor-${s.name.toLowerCase().replace(/\s+/g, "-")}`}
                >
                  <p className="font-display text-2xl font-normal text-[#2D2422]">{s.name}</p>
                  <p className="mt-2 font-display text-base italic leading-relaxed text-[#8A7975]">
                    {s.pairing}
                  </p>
                </div>
              </Reveal>
            ))}
          </div>
          <p className="mt-8 font-accent text-[11px] font-semibold uppercase tracking-[0.24em] text-[#C48B71]">
            Available for a limited season &mdash; ask about them in your inquiry
          </p>
        </div>
      </Reveal>

      <Reveal delay={0.2} className="mt-14">
        <p className="font-display text-xl italic text-[#8A7975]" data-testid="flavors-note">
          Have a combination in mind?{" "}
          <button
            onClick={() => scrollToId("#inquiry")}
            className="text-[#C48B71] underline decoration-[#C48B71]/40 underline-offset-4 transition-colors duration-300 hover:text-[#A9715A]"
            data-testid="flavors-inquiry-link"
          >
            Tell us about it
          </button>{" "}
          when submitting your inquiry.
        </p>
      </Reveal>
    </div>
  </section>
);

export default Flavors;
